import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SvgIconModule } from '../../../svg-icon/svg-icon.module';
import { DownloadAppComponent } from './download-app.component';

@NgModule({
    imports: [
        CommonModule,
        SvgIconModule,
    ],
    exports: [DownloadAppComponent],
    declarations: [DownloadAppComponent],
})
export class DownloadAppModule { }
